import { render, staticRenderFns } from "./help_center_upgrade_subscription.vue?vue&type=template&id=4edc8ba0"
import script from "./help_center_upgrade_subscription.vue?vue&type=script&lang=js"
export * from "./help_center_upgrade_subscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports